import * as actionTypes from './types';

const inituelState = {
    loading: false,
    error: false,
    
    otherPropertyDetails: null
};
const otherPropertyDetailsReducer = (state = { ...inituelState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.REQUST_OTHER_PROPERTY_DETAILS:
            return {
                ...state,
                loading: true
            };
        case actionTypes.FAILED_OTHER_PROPERTY_DETAILS:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case actionTypes.SUCCESS_OTHER_PROPERTY_DETAILS:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false
            };

      
        default:
            return {
                ...state
            };
    }
};

export default otherPropertyDetailsReducer;
